import { type ReactNode } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchAquariums } from '../services/aquariumService';
import { ActiveAquariumProvider } from './AquariumContext';

interface ActiveAquariumDataProviderProps {
  children: ReactNode;
}

/**
 * Fetches the user's aquariums and feeds them into ActiveAquariumProvider,
 * which itself only manages *which* aquarium is active — it does not fetch
 * data. Mounted once at the app root (inside AuthProvider) so the header
 * switcher, sidebar links, and routing sync all share one aquarium list and
 * one active-aquarium selection.
 */
export function ActiveAquariumDataProvider({ children }: ActiveAquariumDataProviderProps) {
  const { data: aquariums = [] } = useQuery({
    queryKey: ['aquariums'],
    queryFn: fetchAquariums,
  });

  return <ActiveAquariumProvider aquariums={aquariums}>{children}</ActiveAquariumProvider>;
}

export default ActiveAquariumDataProvider;
